import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      key: "ja_adws",
//      paths: ["token"],
      storage: window.sessionStorage,
      ssr: false
    }),
  ],
  state: {
    initializedAnalize: false,
    initializedUser: false,
    analizeTypeGroupList:[],
    analizeTypeList:[],
    analizeSetList:[],
    analizeItemList:[],
    standardValueList:[],
    employee:{},
    mycompany:{},
    myoffice:{},
    operatingOffice:{},
    operatingCompany:{},
    officeList:[],
//    units: [],
    useUnits: [],
    liquidUnits: [],
    count: 0,
    isAdmin: false,
    isSystemAdmin: false,
    isUserAdmin: false,
    isSuperUser: false,
    isDeveloper: false,
    isStaff: false,
    oilTypeCategoryList:[],
    oilTypeList:[],
    isContractCompany: false,
  },
mutations: {
/*
    setUnits : function(state, units) {
      state.units = units
    },
*/
    setUseUnits : function(state, useUnit) {
      state.useUnits = useUnit
    },
    setLiquidUnits : function(state, liquidUnit) {
      state.liquidUnits = liquidUnit
    },
/* 
    setAnalizeTypeGroupList : function(state, analizetypeGroups) {
      state.analizeTypeGroupList = analizetypeGroups
    },
    setAnalizeTypeList : function(state, analizetypes) {
      state.analizeTypeList = analizetypes
    },
    setAnalizeSetList : function(state, analizeSets) {
      state.analizeSetList = analizeSets
    },
    setAnalizeItemList : function(state, analizeItems) {
      state.analizeItemList = analizeItems
    },
*/
    setStandardValueList : function(state, standardValues) {
      state.standardValueList = standardValues
    },
    setMyCompany : function(state, company) {
      state.mycompany = company
      state.operatingCompany = company
    },
    setEmployee : function(state, employee) {
      state.employee = employee
    },
    setMyOffice : function(state, office) {
      state.myoffice = office
      state.operatingOffice = office
    },
    setOperatingOffice : function(state, office) {
      state.operatingOffice = office
    },
    setOperatingCompany : function(state, company) {
      state.operatingCompany = company
    },
    setOfficeList : function(state, offices) {
      state.officeList = offices
    },
    setAdmin : function(state, isAdmin) {
      state.isAdmin = isAdmin
    },
    setSystemAdmin : function(state, isSystemAdmin) {
      state.isSystemAdmin = isSystemAdmin
    },
    setUserAdmin : function(state, isUserAdmin) {
      state.isUserAdmin = isUserAdmin
    },
    setSuperUser : function(state, isSuperUser) {
      state.isSuperUser = isSuperUser
    },
    setDeveloper : function(state, isDeveloper) {
      state.isDeveloper = isDeveloper
    },
    setStaff : function(state, isStaff) {
      state.isStaff = isStaff
    },
    setInitializedAnalize : function(state, initializedAnalize) {
      state.initializedAnalize = initializedAnalize
    },
    setInitializedUser : function(state, initializedUser) {
      state.initializedUser = initializedUser
    },
    setOilTypeCategoryList : function(state, oilTypeCategoryList) {
      state.oilTypeCategoryList = oilTypeCategoryList
    },
    setOilTypeList : function(state, oilTypeList) {
      state.oilTypeList = oilTypeList
    },
    setContractCompany : function(state, isContractCompany) {
      state.isContractCompany = isContractCompany
    },
  },
  actions: {
  },
  modules: {
  }
})
